export const containerMaxW = 'xl:max-w-7xl xl:mx-auto'
